import React from "react";
import { useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import { actions as debinActions } from "reducers/debin";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import EmitDebinSummaryBody from "./components/Summary";

const RejectDebinSummaryPage = () => {
    const { debinDetail, sentRequests, debinTicket } = useSelector((state) => state.debin);
    const { accounts } = useSelector((state) => state.accounts);
    const receivedDebin = sentRequests?.debinList?.find((object) => object.id === debinDetail?.id);
    const accountBuyer = accounts?.find((object) => object?.cbu?.substring(9) === receivedDebin?.buyer?.cbu);

    const debitAccountMask = accountBuyer ? `****${accountBuyer?.shortLabel?.substring(1)}` : "";

    const data = {
        currency: debinDetail?.amount?.currency || debinDetail?.currency,
        amount: debinDetail?.amount?.quantity || debinDetail?.amount,
        idDebin: debinDetail?.id || debinDetail?.debinId,
        idAccount: accountBuyer?.productId || debinDetail?.idAccount,
        amountSumary: debinDetail?.amount?.quantity || debinDetail?.amountSumary,
        curencySeller: debinDetail?.amount?.currency || debinDetail?.curencySeller,

        debitAccountMask: debitAccountMask || debinDetail?.debitAccountMask || "-",
        sellerName: debinDetail?.sellerDetail?.titular || debinDetail?.sellerName || "-",
        sellerCuit:
            `${debinDetail?.sellerDetail?.documentType} ${debinDetail?.sellerDetail?.documentNumber}` ||
            debinDetail?.sellerCuit ||
            "-",
        solicitDate: debinDetail?.creationDate || debinDetail?.solicitDate || "-",
        dueDate: debinDetail?.expirationDate || debinDetail?.dueDate || "-",
        debinId: debinDetail?.id || debinDetail?.debinId || "-",
        sellerCbu: debinDetail?.sellerDetail?.cbu || debinDetail?.sellerCbu || "-",
        alias: debinDetail?.sellerDetail?.cbuAlias || debinDetail?.alias || "-",
        bank: debinDetail?.sellerDetail?.bank || debinDetail?.bank || "-",
        concept: debinDetail?.concept || "-",
        description: debinDetail?.description || "-",
        reference: debinDetail?.reference || "-",
        idTransaction: debinDetail?.idTransaction,
    };

    useConfirmTransaction(data, debinTicket, "debinPayments/reject");

    return (
        <>
            <Notification scopeToShow="/debinPayments" />
            <ResponsiveHeader id="debin.reject.received" />
            <MainContainer>
                <div className="container debin-payments__reject">
                    <I18n id="echecks.summary.reject.aval" />
                    <EmitDebinSummaryBody
                        debitAccountMask={data.currency || "-"}
                        sellerName={data.sellerName || "-"}
                        sellerCuit={data.sellerCuit}
                        curencySeller={data.curencySeller}
                        amountSumary={data.amountSumary}
                        solicitDate={data.solicitDate}
                        dueDate={data.dueDate}
                        debinId={data.debinId}
                        sellerCbu={data.sellerCbu}
                        alias={data.alias}
                        bank={data.bank}
                        concept={data.concept}
                        description={data.description}
                        reference={data.reference}
                    />
                    <GeneralCredentialForm
                        transactionData={data}
                        action={debinActions.declineIncomingRequestSend}
                        idActivity="debin.incoming.decline.send"
                        hideIndications
                        customClass="mt-7"
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default RejectDebinSummaryPage;
